import { TextField } from "@mui/material";
import { useState } from "react";

export default function Filter({
  filterData,
  onFilterSubmit,
  Onclear,
  setFilterData,
  page,
}) {
  const show = (value) => value !== undefined;
  const [errors, setErrors] = useState({});
  const today = new Date().toISOString().split("T")[0];

  const {
    uniqueId,
    phone,
    orderId,
    pgorderId,
    quoteId,
    mmtcRefNo,
    customerRefNo,
    startDate,
    endDate,
    name,
    accountNo,
    panNo,
    transactionId,
    merchantTransactionId,
    invoiceId,
    status,
    metalType,
    eyebtnforinvoice,
  } = filterData;
  const showheading = () => {
    switch (page) {
      case "User":
        return "User List";
      case "Pan":
        return "Pan List";
      case "Bank":
        return "Bank List";
      case "Addresses":
        return "Addresses List";
      case "mmtc_sell_req":
        return "MMTC-PAMP Sell Request";
      case "mmtc_sell_res":
        return "MMTC-PAMP Sell Response";
      case "augmont_sell_req":
        return "Augmont Sell Request";
      case "augmont_sell_res":
        return "Augmont Sell Response";
      case "mmtc_redeem":
        return "MMTC-PAMP Redeem";
      case "augmont_redeem":
        return "Augmont Redeem";
      case "augmont_buy_req":
        return "Augmont Buy Request";
      case "augmont_buy_res":
        return "Augmont Buy Response";
      case "mmtc_buy_request":
        return "MMTC-PAMP Buy Request";
      case "mmtc_buy_response":
        return "MMTC-PAMP Buy Response";

      default:
        return "Dashboard"; // fallback
    }
  };

  const validateOnChange = (name, value, allValues) => {
    let error = "";

    // Normalize today's date (remove time)
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const selectedDate = value ? new Date(value) : null;
    if (selectedDate) selectedDate.setHours(0, 0, 0, 0);

    const normalize = (date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };

    switch (name) {
      case "startDate":
        if (selectedDate && selectedDate > todayDate) {
          error = "Start date cannot be in the future";
          break;
        }

        if (
          allValues.endDate &&
          selectedDate &&
          selectedDate > normalize(allValues.endDate) // ❗ Only greater than
        ) {
          error = "Start date must be less than or equal to End date";
        }
        break;

      case "panNo": {
        const val = value.toUpperCase();
        const len = val.length;

        if (len > 10) {
          error = "PAN cannot be more than 10 characters";
          break;
        }

        if (len <= 5) {
          if (/[^A-Z]/.test(val[len - 1])) {
            error = "First 5 characters must be alphabets";
          }
          break;
        }

        if (len > 5 && len <= 9) {
          if (/[^0-9]/.test(val[len - 1])) {
            error = "Characters 6 to 9 must be numbers";
          }
          break;
        }

        if (len === 10) {
          if (/[^A-Z]/.test(val[9])) {
            error = "Last character must be an alphabet";
          }
          break;
        }

        break;
      }

      case "endDate":
        if (selectedDate && selectedDate > todayDate) {
          error = "End date cannot be in the future";
          break;
        }

        if (
          allValues.startDate &&
          selectedDate &&
          selectedDate < normalize(allValues.startDate) // ❗ Only less than
        ) {
          error = "End date must be greater than or equal to Start date";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const handleFilterChange = (e) => {
    const { name, type, value, checked } = e.target;
    let fieldValue = type === "checkbox" ? checked : value;

    // Phone specific logic
    if (name === "phone") {
      // allow backspace / clear
      if (value.length === 0) {
        setErrors((prev) => ({ ...prev, phone: "" }));
        setFilterData((prev) => ({ ...prev, phone: "" }));
        return;
      }

      // if non-digit typed
      if (/[^0-9]/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone number can contain only numbers",
        }));
        return;
      }

      // if length exceeds 10
      if (value.length > 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone number cannot exceed 10 digits",
        }));
        return;
      }

      // valid input
      fieldValue = value;
      setErrors((prev) => ({ ...prev, phone: "" }));
    }

    if (name === "panNo") {
      const rawValue = value.toUpperCase();

      // allow backspace / clear
      if (rawValue.length === 0) {
        setErrors((prev) => ({ ...prev, panNo: "" }));
        setFilterData((prev) => ({ ...prev, panNo: "" }));
        return;
      }

      let error = "";
      const len = rawValue.length;

      if (len > 10) {
        error = "PAN cannot be more than 10 characters";
      } else if (/[^A-Z0-9]/.test(rawValue)) {
        error = "Only alphabets and numbers allowed";
      } else if (
        len <= 5 &&
        rawValue[len - 1] &&
        /[^A-Z]/.test(rawValue[len - 1])
      ) {
        error = "First 5 characters must be alphabets";
      } else if (len > 5 && len <= 9 && /[^0-9]/.test(rawValue[len - 1])) {
        error = "Characters 6 to 9 must be numbers";
      } else if (len === 10 && /[^A-Z]/.test(rawValue[9])) {
        error = "Last character must be an alphabet";
      }

      if (error) {
        setErrors((prev) => ({ ...prev, panNo: error }));
        return;
      }

      fieldValue = rawValue.replace(/[^A-Z0-9]/g, "");
    }

    // Update filter data state
    setFilterData((prev) => ({
      ...prev,
      [name]: fieldValue,
    }));

    // Validate ON CHANGE
    const error = validateOnChange(name, fieldValue, {
      ...filterData,
      [name]: fieldValue,
    });

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  return (
    <div>
      <div className="transition-colors duration-200 mb-8">
        <div className="w-full ">
          <div className="bg-card-light rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="px-6 py-5 border-b border-slate-100 flex items-center justify-between">
              <h1 className="text-xl font-bold text-slate-800">
                {showheading()}
              </h1>
            </div>
            <div className="p-6">
              <form onSubmit={onFilterSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
                  {show(name) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Name</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="Name"
                        name="name"
                        size="small"
                        type="text"
                        fullWidth
                        value={filterData.name || ""} // controlled input
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}
                  {show(phone) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Phon Number</label> */}
                      <div className="relative">
                        {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all placeholder:text-slate-400" placeholder="dd/mm/yyyy" type="date" /> */}
                        <TextField
                          label="Phone Number"
                          name="phone"
                          size="small"
                          type="text"
                          fullWidth
                          value={filterData.phone || ""}
                          onChange={handleFilterChange}
                          error={Boolean(errors.phone)}
                          helperText={errors.phone}
                        />
                      </div>
                    </div>
                  )}

                  {show(uniqueId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Unique Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="Unique Id"
                        name="uniqueId"
                        size="small"
                        type="text"
                        fullWidth
                        value={filterData.uniqueId || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(customerRefNo) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Customer Referance Number</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="Customer Ref Number"
                        size="small"
                        name="customerRefNo"
                        type="text"
                        fullWidth
                        value={filterData.customerRefNo || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(invoiceId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Invoice Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="Invoice Id"
                        name="invoiceId"
                        size="small"
                        type="text"
                        fullWidth
                        value={invoiceId || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(orderId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Order Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="Order Id"
                        name="orderId"
                        size="small"
                        type="text"
                        fullWidth
                        value={orderId || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(pgorderId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">PG Order Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="PGOrder Id"
                        name="pgorderId"
                        size="small"
                        type="text"
                        fullWidth
                        value={pgorderId || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(quoteId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Quote Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" placeholder="Enter unique id" type="text" /> */}
                      <TextField
                        label="Quote Id"
                        name="quoteId"
                        size="small"
                        type="text"
                        fullWidth
                        value={quoteId || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(mmtcRefNo) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Customer Referance Number</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="MMTC Referance Number"
                        size="small"
                        name="mmtcRefNo"
                        type="text"
                        fullWidth
                        value={filterData.mmtcRefNo || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(panNo) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Pan Number</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="Pan Number"
                        name="panNo"
                        size="small"
                        type="text"
                        fullWidth
                        value={filterData.panNo || ""}
                        onChange={handleFilterChange}
                        error={Boolean(errors.panNo)}
                        // error={errors.panNo}
                        helperText={
                          errors.panNo || "Pan Format Must be 'AAAAA9999A'"
                        }
                      />
                    </div>
                  )}
                  {show(accountNo) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Bank Account Number</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="Account No"
                        name="accountNo"
                        size="small"
                        type="text"
                        fullWidth
                        value={filterData.accountNo || ""}
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}
                  {show(transactionId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Transaction Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="Transaction Id"
                        name="transactionId"
                        size="small"
                        value={transactionId}
                        type="text"
                        fullWidth
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}

                  {show(merchantTransactionId) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">Merchant Transaction Id</label> */}
                      {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all" type="text" /> */}
                      <TextField
                        label="Merchant Transaction Id"
                        name="merchantTransactionId"
                        size="small"
                        value={merchantTransactionId}
                        type="text"
                        fullWidth
                        onChange={handleFilterChange}
                      />
                    </div>
                  )}
                  {show(status) && (
                    <div className="space-y-1.5">
                      <label className="text-sm font-medium text-slate-700">
                        Status
                      </label>
                      <select
                        className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all appearance-none cursor-pointer"
                        value={filterData.status || ""}
                        name="status"
                        onChange={handleFilterChange}
                      >
                        <option>Select a Status</option>
                        <option value="pending">Pending</option>
                        <option value="completed">Completed</option>
                        <option value="failed">Failed</option>
                      </select>
                    </div>
                  )}

                  {show(metalType) && (
                    <div className="space-y-1.5 relative">
                      <select
                        value={filterData.metalType || ""}
                        name="metalType"
                        onChange={handleFilterChange}
                        className="w-full px-3 py-2 pr-10 bg-white border border-slate-300 rounded-md
                 focus:ring-2 focus:ring-primary focus:border-primary text-slate-900
                 outline-none transition-all appearance-none cursor-pointer"
                      >
                        <option value="" disabled hidden>
                          Select Metal Type
                        </option>
                        <option value="gold">Gold</option>
                        <option value="silver">Silver</option>
                      </select>

                      {/* Dropdown Icon */}
                      <span className="pointer-events-none absolute right-3 top-1/3 -translate-y-1/2 text-slate-500">
                        ▼
                      </span>
                    </div>
                  )}

                  {show(startDate) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">From Date</label> */}
                      <div className="relative">
                        {/* <input className="w-full px-3 py-2 bg-white border border-slate-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all placeholder:text-slate-400" placeholder="dd/mm/yyyy" type="date" /> */}
                        <TextField
                          label="Start Date"
                          size="small"
                          name="startDate"
                          type="date"
                          fullWidth
                          value={filterData.startDate || ""}
                          onChange={handleFilterChange}
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ max: today }}
                          error={Boolean(errors.startDate)}
                          helperText={errors.startDate}
                        />
                      </div>
                    </div>
                  )}
                  {show(endDate) && (
                    <div className="space-y-1.5">
                      {/* <label className="text-sm font-medium text-slate-700">To Date</label> */}
                      {/* <input className="w-full px-3 py-2  rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-slate-900 outline-none transition-all placeholder:text-slate-400" placeholder="dd/mm/yyyy" type="date" /> */}
                      <TextField
                        label="End Date"
                        size="small"
                        name="endDate"
                        type="date"
                        fullWidth
                        value={filterData.endDate || ""}
                        onChange={handleFilterChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          max: today,
                          min: filterData.startDate || undefined,
                        }}
                        error={Boolean(errors.endDate)}
                        helperText={errors.endDate}
                      />
                    </div>
                  )}

                  {/* SWITCH====== */}
                </div>
                <div className="flex flex-wrap gap-4 pt-4">
                  <button
                    className="bg-primary hover:bg-opacity-90 text-white font-semibold py-2.5 px-8 rounded-md transition-all shadow-sm active:scale-95 flex items-center gap-2"
                    type="submit"
                  >
                    Filter
                  </button>
                  <button
                    onClick={Onclear}
                    className="bg-slate-500 hover:bg-slate-600 dark:hover:bg-slate-600 text-white font-semibold py-2.5 px-8 rounded-md transition-all shadow-sm active:scale-95 flex items-center gap-2"
                    type="button"
                  >
                    Clear Filters
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
